import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const IconContainer = styled.div`
    max-width: 10rem;
    width: 100%;
    aspect-ratio: 1/1;
`;

export const NotFoundWrapper = styled.div`
    border-radius: ${getPurpurBorder('radiusLg')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderMedium')};

    display: flex;
    padding: ${getPurpurSpacing('300')} ${getPurpurSpacing('300')} ${getPurpurSpacing('600')} ${getPurpurSpacing('300')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${getPurpurSpacing('200')};
`;

export const Centered = styled(Container).attrs({ width: 'md', element: 'span' })`
    text-align: center;
`;
